import { render, staticRenderFns } from "./paperslist.vue?vue&type=template&id=79ba0154&"
import script from "./paperslist.vue?vue&type=script&lang=js&"
export * from "./paperslist.vue?vue&type=script&lang=js&"
import style0 from "./paperslist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports